<template>
    <div class="component-timeline">
      <div class="component-timeline-gaps">
        <span v-for="item in internalValue.gap" v-if="item.percentage > 0" class="component-timeline-gaps-item" v-bind:style="{'width': 'calc(' + item.percentage + '% - 2px)'}" :title="item.days + ' jour(s)'">
          <span v-if="item.days > internalValue.average" v-bind:style="{width: (110 - (internalValue.average * 100 / item.days)) + '%'}"></span>
        </span>
      </div>
      <div class="component-timeline-orders">
        <a :href="item.download_link" target="_blank" v-for="item in internalValue.timeline" class="component-timeline-orders-item" v-bind:style="{left: item.percentage + '%'}" :title="item.reference">
          <span class="order-state success" v-if="item.payment_status == 'completed'"><i class="icon icon-order-success"></i></span>
          <span class="order-state pending" v-if="item.payment_status == 'pending'"><i class="icon icon-icon_clock"></i></span>
          <span class="order-state canceled" v-if="item.payment_status == 'canceled'"><i class="icon icon-order-cancel"></i></span>
          <span class="order-state draft" v-if="item.payment_status == 'draft'"><i class="icon icon-order-pending"></i></span>
          <img src="/src/assets/images/timeline-marker.png"/>
        </a>
      </div>
      <div class="component-timeline-years">
        <span v-for="item in internalValue.years" class="component-timeline-years-item" v-bind:style="{width: item.percentage + '%'}">
          <span>{{ item.label }}</span>
        </span>
      </div>
    </div>
</template>

<script>
    export default {
        name: 'Active',
        props: ['value','label','name','placeholder'],
        data: function () {
            return {
                internalValue: ''
            }
        },
        created: function() {
            this.internalValue = this.value;
        },
        methods: {
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            },
            'internalValue'(newVal, oldVal) {
                this.$emit('input', this.internalValue);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Timeline.vue